import React from "react";
import playButton from "../images/playbutton.svg";

const BannerSlider = () => {
  const handleGetStarted = () => {
    const featuredSection = document.getElementById("featuredSection");
    if (featuredSection) {
      featuredSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Use the first banner only (you can replace or modify content easily)
  const slide = {
    title: "Learn to Drive",
    subtitle: "With Confidence!",
    description:
      "Our Driving Academy offers expert guidance, interactive lessons, and practical tips to help you become a skilled and confident driver.",
  };

  return (
    <div className="banner">
      <div className="content">
        <h2>
          {slide.title} <br />
          <span>{slide.subtitle}</span>
        </h2>
        <p className="description">{slide.description}</p>
        <div className="d-flex mt-5">
          <button className="btn1" onClick={handleGetStarted}>
            Get Started
          </button>
          <img src={playButton} alt="Play" className="playbutton" />
        </div>
      </div>
    </div>
  );
};

export default BannerSlider;
